import React from "react";
import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { Link } from "react-router-dom";
import { ReactComponent as LinkIconSvg } from "../../../../assets/appearencePage/link 2.svg";
import { ReactComponent as LinkIconSvgDark } from "../../../../assets/appearencePage/link 2-dark.svg";
import { LinkAcc } from "../../largeScreen/appearance/accordions";
import useLocales from "../../../../hooks/useLocales";
import useSettings from "../../../../hooks/useSettings";
import { useSelector } from "react-redux";

const Links = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();

  return (
    <div className="px-6">
      <div className="md:hidden mt-10 mb-10 ">
        <Link className="flex items-center gap-3" to={"/dashboard/appearance"}>
          <div className=" flex items-center justify-center">
            {darkMode ? (
              <LeftArrowDark
                className={`h-[20px] w-[20px] ${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            ) : (
              <LeftArrow
                className={`h-[20px] w-[20px] ${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            )}
          </div>
          <h6 className="w-full text-body_copy2 dark:text-color_v1_dark">
            {/* LINK */}
            {translate("appearance.link_cap")}
          </h6>
        </Link>
      </div>

      <div
        className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary dark:text-color_v1_dark rounded-[10px] px-[25px] py-[30px] mb-10 border border-light_bg_v2`}
      >
        <div className="flex  gap-2 justify-between items-center cursor-pointer">
          <div>
            {darkMode ? (
              <LinkIconSvgDark width={20} height={20} />
            ) : (
              <LinkIconSvg width={20} height={20} />
            )}
          </div>

          <div className="text-small2_b text-heading_color w-full dark:text-color_v1_dark">
            <h1>
              {/* LINK */}
              {translate("appearance.link_cap")}
            </h1>
          </div>
        </div>
        <LinkAcc />
      </div>
    </div>
  );
};

export default Links;
